import type { ReactNode } from 'react';
import { SkullIcon } from './icons/SkullIcon';
import { SwordsIcon } from './icons/SwordsIcon';
import { TornadoIcon } from './icons/TornadoIcon';

interface GameModeInfoItem {
  icon: ReactNode;
  title: string;
  desc: string;
}

const GAME_MODE_INFO: GameModeInfoItem[] = [
  {
    icon: <SwordsIcon size={18} className="text-water-light" />,
    title: 'Classic',
    desc: 'Balanced mode. After each round you regain energy from the result: win +5, lose +15, draw +10.',
  },
  {
    icon: <SkullIcon size={18} className="text-fire" />,
    title: 'Hardcore',
    desc: 'No energy returns between rounds. Basic moves stay safer, enhanced moves require careful timing.',
  },
  {
    icon: <TornadoIcon size={18} className="text-purple-400" />,
    title: 'Chaos',
    desc: 'Each round uses deterministic server regen from 0 to 20 energy, so plans must survive variance.',
  },
];

interface GameModeInfoSectionProps {
  className?: string;
}

export function GameModeInfoSection({ className = '' }: GameModeInfoSectionProps) {
  return (
    <section className={className}>
      <div className="arena-section-label mb-3">
        Game Modes
      </div>
      <div className="flex flex-col gap-3 text-xs text-text-secondary">
        {GAME_MODE_INFO.map((mode) => (
          <div key={mode.title} className="flex items-start gap-3">
            <span className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg border border-bg-border bg-bg-card">
              {mode.icon}
            </span>
            <div>
              <div className="font-semibold text-text-primary">{mode.title}</div>
              <div className="leading-snug">{mode.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
